export default function Member(props) {
  const {avatar, name, job, description} = props
  return (
    <div className='memberContainer'>
      <img src={avatar} alt='avatar' /> 
      <div className='memberName'>{name}</div>
      <div className='memberJob'>{job}</div>
      {
        description.map((des,item) => {
          return (
            <div className='memberDescription' key={item}>{des}</div>
          )
        })
      }
    </div>
  )
}